export class Country {
  public alpha3code: string;
  public code: string;
  public name: string;
}
